import { showAutoPlacePanelState } from "~/containers/LegacyDesigner/SidePanel/AutoPlacePanelButton"

import type { TransactionOperation } from "."
import { autoPlacePanels } from "."
import { panelIndex } from "../panels"

export const tryToAutoPlacePanelsOnTransition: TransactionOperation = (
  transactors,
) => {
  const { get } = transactors
  const panelIds = get(panelIndex)

  if (get(showAutoPlacePanelState)) return
  if (panelIds.length === 0) {
    autoPlacePanels(transactors)
  }
}
